// @ts-ignore
import { GandalfArray } from 'gandalf';
// @ts-ignore
import { GandalfConstantDecorator } from 'gandalf';
// @ts-ignore
import { GandalfLabel } from 'gandalf';
// @ts-ignore
import { GandalfModel } from 'gandalf';
// @ts-ignore
import { GandalfModelBase } from 'gandalf';
// @ts-ignore
import { GandalfProperty } from 'gandalf';
// @ts-ignore
import { GandalfSubRequestLabel } from 'gandalf';
// @ts-ignore
import { GandalfValidator } from 'gandalf';
// @ts-ignore
import * as constants from '../constants';


/** See com.rev360.pms.api.controller.order.OpenOrderResponse */
/* istanbul ignore next */
@GandalfModel
export class OpenOrderResponse extends GandalfModelBase {

	@GandalfProperty({ designType: Number })
	orderId!: number | null;

	@GandalfConstantDecorator(constants.OrderType)
	@GandalfProperty({ designType: constants.OrderType })
	orderType!: constants.OrderType | null;

	@GandalfConstantDecorator(constants.OrderProcessorType)
	@GandalfProperty({ designType: constants.OrderProcessorType })
	processorType!: constants.OrderProcessorType | null;

	@GandalfProperty({ designType: String })
	vendorSmartflowCode!: string | null;

}
